var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotifications = function SvgIconNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E7E7E",
    d: "M7.34 2.99c-2.683.69-4.665 3.124-4.665 6.023v4.145c0 .382-.31.691-.69.691-.763 0-1.382.62-1.382 1.382v1.037c0 .19.153.345.346.345h15.89c.19 0 .346-.157.346-.345v-1.037c0-.763-.622-1.382-1.383-1.382-.381 0-.69-.307-.69-.691V9.013c0-2.898-1.981-5.332-4.664-6.022v-.714c0-.86-.696-1.555-1.554-1.555-.857 0-1.555.696-1.555 1.555v.713zm-.865 14.314h4.837c0 1.335-1.083 2.418-2.418 2.418-1.336 0-2.419-1.083-2.419-2.418z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-notifications.023603c6.svg";
export { ForwardRef as ReactComponent };